"use client"
import React, {useEffect, useRef, useState} from 'react';
import ScrollNavigationComment from "@/app/product/[slug]/_component/scroll-navigation-comment";
import {SingleProductEnum} from "@/constants/commerce-enum";
import MobileCommentsContainers from "@/app/product/[slug]/_component/containers/mobile-comments-containers";
import AddNewComment from "@/components/ui/add-new-comment/add-new-comment";

function UserCommentMobileComponent({data}: any) {
    const [isOpen, setIsOpen] = useState(false);
    const [isAddCommentOpen, setIsAddCommentOpen] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [sortOrder, setSortOrder] = useState<'newest' | 'oldest'>('newest');
    const dropdownRef = useRef<HTMLDivElement>(null);

    const sortedComments = Object.values(data?.data?.productComments || []).sort((a: any, b: any) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return sortOrder === 'newest' ? dateB - dateA : dateA - dateB;
    });

    const handleSort = (order: 'newest' | 'oldest') => {
        setSortOrder(order);
        setShowFilters(false);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowFilters(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <section id={"comment-header-section"} className='w-full flex flex-wrap justify-between mt-5 items-center'>
                <div className="w-1/2 flex font-bold gap-2 flex-wrap items-center">
                    <h5 className={"text-base"}>
                        {SingleProductEnum.usersComments}
                    </h5>
                    <span className="text-orange-primary text-xs">
                        {sortedComments.length} {""}
                        {SingleProductEnum.comment}
                    </span>
                </div>
                <div className="w-1/4 items-center justify-end flex">
                    <AddNewComment
                        id={data?.data?.product?.id}
                        title={data?.data?.product?.title}
                        isOpen={isAddCommentOpen}
                        onOpenChange={setIsAddCommentOpen}
                        onCloseFirstModal={() => setIsOpen(false)}
                    />
                </div>
                <ScrollNavigationComment/>
            </section>

            <MobileCommentsContainers sortedComments={sortedComments} isOpen={isOpen} data={data}
                                      isAddCommentOpen={isAddCommentOpen} setIsAddCommentOpen={setIsAddCommentOpen}
                                      setIsOpen={setIsOpen} showFilters={showFilters} setShowFilters={setShowFilters}
                                      dropdownRef={dropdownRef} handleSort={handleSort}/>
        </>
    );
}

export default UserCommentMobileComponent;